import { Button, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";

export default function ServerErrorPage() {
  return (
    <VStack minH={"100vh"} gap={0}>
      <VStack p={8} flex={1} justify={"center"} gap={4}>
        {/* <Image src="/vector/error500.png" maxW={"360px"} /> */}

        <Text textAlign={"center"} fontSize={32} fontWeight={600}>
          500 Internal Server Error
        </Text>

        <Text textAlign={"center"} mb={4} maxW={"600px"} opacity={0.5}>
          Server kami saat ini sedang mengalami gangguan. Tim teknisi kami
          sedang mengupayakan perbaikan. Mohon bersabarlah, dan kami akan segera
          memperbaiki semuanya agar kembali lancar
        </Text>

        <Button
          w={"100%"}
          maxW={"300px"}
          variant={"outline"}
          colorScheme="ap"
          className="lg-clicky"
          onClick={() => {
            window.history.back();
          }}
          mb={2}
        >
          Back
        </Button>

        <Button
          variant={"unstyled"}
          className="lg-clicky"
          as={Link}
          to={"/"}
          mx={"auto"}
          color={"p.500"}
        >
          Go to Landing Page
        </Button>
      </VStack>
    </VStack>
  );
}
